<template>

  <div class="column">
    <div class="cover"><img src="../assets/book-cover-2.png" /></div>
    <!-- ========================================== -->
    <div class="mint-area">
      <button v-if="!signed_in" class="btn-mint" v-on:click="signIn()">
        <span>- CONNECT WALLET -</span>
      </button>

      <div v-if="signed_in">
        <div v-if="wrongNetwork">
          <p class="mt-3">Please connect to the correct network.</p>
        </div>
        <div v-else-if="!sale_started">
          <p class="pt-3">SALE NOT STARTED YET!</p>
          <p class="pt-3 pb-3">Please check back soon!</p>
        </div>
        <div v-else-if="totalMinted === maxTokens">
          <p>SOLD OUT!</p>
          <a href="https://opensea.io/" target="_blank" class="mt-1 button is-link" >
            Buy on OpenSea
          </a>
        </div>
        <div v-else>

          <button v-if="signed_in" class="btn-mint active" >
            <span>WALLET CONNECTED</span>
          </button>

          <div v-if="!is_minting && !minted && !has_failed">
            <div class="price">
              <p class="mb-1">{{ totalMinted }} / 376 minted</p>
              <p class="mb-1">Price 0<span class="eth">&Xi;</span></p>
            </div>
            <div>
              <input
                class="input number-of-mints"
                type="number"
                v-model="how_many_tokens"
                placeholder="1"
              />
            </div>
            <div>
              <button class="btn-mint btn-mint-final" v-on:click="mintToken(1)">
                <span>MINT Book 2</span>
              </button>
            </div>
            <p class="mt-3 has-text-danger" v-if="user_error">
              {{ user_error_message }}
            </p>
          </div>

          <!-- =========================== MINTING =========================== -->

          <div v-if="is_minting && !minted && !has_failed" class="mt-3 pb-4">
            <p>Minting NFTs...</p>
            <progress class="progress is-small is-primary mt-3" max="100">
              15%
            </progress>
          </div>

          <!-- =========================== ETHERSCAN =========================== -->

          <div v-if="!minted && transaction_hash != null" class="notification is-link">
            Transaction created:
            <a target="_blank" :href="`https://etherscan.io/tx/${transaction_hash}`" >View on Etherscan</a>
          </div>

          <!-- =========================== SUCCESS =========================== -->
          <div v-else-if="minted">
            <div class="notification is-success mt-5">SUCCESS! You have minted your NFTs!</div>
            <div class="view-on-opensea">
              <a :href="`https://opensea.io/${wallet_address}`" target="_blank">View on OpenSea</a>
            </div>
          </div>

          <!-- =========================== ERROR =========================== -->

          <div v-else-if="has_failed" class="notification is-warning">
            {{ error_message }}
            <div><a v-on:click="reset()">Reset</a></div>
          </div>

          <!-- =========================== END =========================== -->
        </div>
      </div>
    </div>
    <!-- ========================================== -->
  </div>


</template>

<!-- ============================================================================ -->

<script>
import Web3 from "web3";
import { ADDRESS, ABI } from "../../config.js";
export default {
  name: "Mint",
  data() {
    return {
      signed_in: false,
      is_minting: false,
      wallet_address: null,
      how_many_tokens: 1,
      contract: null,
      contract_address: null,
      total_supply: 0,
      sale_started: true,
      token_price: 0,
      transaction_hash: null,
      minted: false,
      last_receipt: null,
      has_failed: false,
      wrongNetwork: false,
      error_message: "",
      user_error: false,
      user_error_message: "",
      whitelisterror: false,
      loading: true,
      totalMinted: 0,
      totalPurchased: 0,
      totalReserved: 0,
      maxTokens: 0
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      this.callContractData();
    });
  },
  methods: {
    reset() {
      this.has_failed = false;
    },
    async signIn() {
      if (this.signed_in) {
        return;
      }

      this.loading = true;
      this.whitelisterror = false;

      if (typeof window.web3 !== "undefined") {
        // Use existing gateway
        window.web3 = new Web3(window.ethereum);
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "No Ethereum interface injected into browser. Read-only access"
        );
      }

      if (window.ethereum) {
        let self = this;
        try {
          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          window.web3.eth.net.getNetworkType().then((network) => {
            if (network != process.env.VUE_APP_ETHNETWORK) {
              self.wrongNetwork = true;
            }
          });

          let wallet = accounts[0];

          // if(self.isPreSale()) {
          self.signed_in = true;
          self.wallet_address = wallet;

          self.loading = false;
          self.callContractData();
        } catch (error) {
          if (error.code === 4001) {
            // User rejected request
          }

          // eslint-disable-next-line no-console
          console.log(error);
        }
      }
    },
    async callContractData() {
      if (typeof window.web3 !== "undefined") {
        // Use existing gateway
        window.web3 = new Web3(window.ethereum);
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "No Ethereum interface injected into browser. Read-only access"
        );
      }

      this.contract = new window.web3.eth.Contract(ABI, ADDRESS);
      this.totalPurchased = await this.contract.methods.totalMinted(1).call();
      this.totalReserved = await this.contract.methods.totalReserved(1).call();
      this.maxTokens = await this.contract.methods.maxTokens(1).call();
      this.totalMinted = Number(this.totalPurchased) + Number(this.totalReserved);
    },
    async mintToken(bookNum) {
      if (this.contract) {
        this.is_minting = true;
        this.has_failed = false;
        this.user_error = false;

        if(this.how_many_tokens == 0) {
          this.error_message = "Must enter number of tokens to purchase.";
          this.has_failed = true;
          this.is_minting = false;
        } else {

          this.transaction_hash = null;
          let self = this;
          const price = this.how_many_tokens * this.token_price;
          const gasAmount = await this.contract.methods
            .purchase(this.how_many_tokens, bookNum)
            .estimateGas({ from: this.wallet_address, value: price })
            .catch(function (error) {
              self.has_failed = true;
              self.is_minting = false;

              if(error.message.includes("Must enter a book number")) self.error_message = "Must enter a book number";
              else if(error.message.includes("Sale for this book is not active")) self.error_message = "Sale for this book is not active";
              else if(error.message.includes("All tokens have been minted for this book")) self.error_message = "All tokens have been minted for this book";
              else if(error.message.includes("Would exceed total supply for this book")) self.error_message = "Would exceed total supply for this book";
              else if(error.message.includes("Would exceed purchase limit for this book")) self.error_message = "Would exceed purchase limit for this book";
              else if(error.message.includes("ETH value is not good")) self.error_message = "ETH value is not good";
              else if(error.message.includes("User denied transaction signature")) self.error_message = "User denied transaction signature";
              else self.error_message = "Insufficient funds for gas. Please add more ETH to your wallet";
            });

          if(!self.has_failed) {
            this.contract.methods
              .purchase(this.how_many_tokens, bookNum)
              .send({
                from: this.wallet_address,
                value: price,
                gas: parseInt(1.2 * gasAmount),
              })
              .on("transactionHash", function (hash) {
                self.transaction_hash = hash;
              })
              .on("error", function () {
                self.is_minting = false;
              })
              .then(function (receipt) {
                self.is_minting = false;
                self.minted = true;
                self.last_receipt = receipt;
              });
          }
        }
      } else {
        // eslint-disable-next-line no-console
        console.log("Wallet not connected");
      }
    },
  },
};
</script>

<!-- ============================================================================ -->

<style scoped>

h1 {
  /* background: #000; */
  color: #fff;
}
  h1 span {
    /* border-bottom: 1px solid #fff; */
    padding-bottom: 10px;
  }

.mint {
  /* background: rgba(255, 255, 255, 0.2); */
  /* max-width: 540px !important; */
  margin: 0 auto;
  /* padding-bottom: 20px; */
  padding: 10px 20px;
}

  .input-box {
    background: #000;
  }

  .mint-container-outer {
    position: relative;
    background: #000;
    /* background: url(../assets/mint-background.jpg) -74px 0 repeat; */
    /* background-size: 1110px; */
  }

  .price {
    font-size: 20px;
  }
    .price p {
      margin-bottom: 0 !important;
      padding-bottom: 5px !important;
    }

  .btn-mint {
    font-size: 18px;
    background: transparent;
    max-width: 200px;
    cursor: pointer;
    margin: 0 auto;
    color: #fff;
    padding: 10px 20px;
    border: 1px solid #fff;
  }
    .btn-mint:hover {
      background: rgba(255, 255, 255, 0.3);
    }
    .btn-mint-final {
      color: #fff;
      font-size: 16px;
      width: 100%;
      background: #E3558D;
      margin: 10px 0 0 0;
    }
    .btn-mint.active {
      display: block;
      position: absolute;
      top: -145px;
      right: 10px;
      opacity: 0.4;
    }
    .btn-mint.active:hover {
      border: none;
      cursor: default;
    }
  .btn-mint .container .label {
    font-size: 36px;
    padding: 10px 20px 0 20px;
  }
  .btn-mint.active .container .label {
    font-size: 12px;
    padding: 10px 20px;
    color: #fff;
  }
  .btn-mint {
    max-width: 100%;
  }
  .btn-mint .container .label.connect {
    font-size: 24px;
    padding: 10px 20px;
    color: #fff;
  }
  .btn-mint-final span {
    font-size: 28px;
    color: #fff;
  }

  #mint {
    padding-bottom: 10px;
  }

  #mint-container {
    /* background: #000; */
    color: #fff;
  }

  .mint p {
    padding-top: 0;
    padding-bottom: 0;
  }

  .mint-inputs {
    /* background: #000; */
  }

  .mint-inputs .how-many {
    padding: 0 10px;
  }

  input.number-of-mints {
    width: 70px;
    margin: 0 0 0 10px;
    text-align: center;
  }

  .progress {
    width: 80%;
    margin: 0 auto;
  }

  .notification {
    background: transparent;
    padding: 20px !important;
  }
  .notification.is-warning {
    margin-top: 0;
    background: #fcc;
    color: #333;
  }
  .notification.is-link {
    padding-top: 0.75rem;
    color: #fff;
  }
  .notification.is-success {
    margin-bottom: 0;
  }
  div.view-on-opensea {
    padding-bottom: 20px;
  }
    div.view-on-opensea a {
      color: #fff;
    }
</style>

<!-- ============================================================================ -->

<style>
body {
  background-color: rgb(88, 179, 224);
  color: #fff;
}

    .book-number {
      font-size: 16px;
    }

.eth {
  font-family: helvetica, arial, sans-serif !important;
}
</style>

<!-- ============================================================================ -->

<style>
@media (max-width: 550px) {}
</style>